import type { SimulationFilterFooterAction } from 'types/ppaSimulationMeta';
import {
    PPA_SIM_FILTER_APPLY_BTN,
    PPA_SIM_FILTER_RESET_BTN,
} from 'constants/ppaTestIds';
import {
    StyledFilterApplyButton,
    StyledFilterPanelFooter,
    StyledFilterPanelFooterActions,
    StyledFilterResetButton,
} from './SimulatorFilterPanel.styles';

type SimulatorFilterPanelFooterProps = {
    footerActions: SimulationFilterFooterAction[];
    isApplyLoading: boolean;
    isApplyingFilters: boolean;
    onFooterAction: (actionId: string) => void | Promise<void>;
};

function normalizeFooterActionId(id: string): string {
    return id.trim().toLowerCase().replace(/-/g, '_');
}

const SimulatorFilterPanelFooter = ({
    footerActions,
    isApplyLoading,
    isApplyingFilters,
    onFooterAction,
}: SimulatorFilterPanelFooterProps) => (
    <StyledFilterPanelFooter className="filter-panel-section">
        <StyledFilterPanelFooterActions>
            {footerActions.map((action) => {
                const normalizedActionId = normalizeFooterActionId(action.id);
                const isApply = normalizedActionId === 'apply';
                const FooterButton = isApply ? StyledFilterApplyButton : StyledFilterResetButton;
                const footerTestId = isApply ? PPA_SIM_FILTER_APPLY_BTN : PPA_SIM_FILTER_RESET_BTN;

                return (
                    <FooterButton
                        key={action.id}
                        type={isApply ? 'primary' : undefined}
                        disabled={action.isLocked || (isApply && (isApplyLoading || isApplyingFilters))}
                        loading={isApply && (isApplyLoading || isApplyingFilters)}
                        data-testid={footerTestId}
                        onClick={() => void onFooterAction(action.id)}
                    >
                        {action.label}
                    </FooterButton>
                );
            })}
        </StyledFilterPanelFooterActions>
    </StyledFilterPanelFooter>
);

export default SimulatorFilterPanelFooter;
